module.exports = __webpack_public_path__ + "ad8b6afde3caa33535a23b52051f8072.pdf";